import { render, staticRenderFns } from "./statisticalEntry.vue?vue&type=template&id=1648af26&scoped=true"
import script from "./statisticalEntry.vue?vue&type=script&lang=js"
export * from "./statisticalEntry.vue?vue&type=script&lang=js"
import style0 from "./statisticalEntry.vue?vue&type=style&index=0&id=1648af26&prod&scoped=true&lang=css"
import style1 from "./statisticalEntry.vue?vue&type=style&index=1&id=1648af26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648af26",
  null
  
)

export default component.exports